export default __webpack_public_path__ + "static/media/filterIcon.c63d2c0a.svg";